import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'

import { UIComponentMap } from 'components/ComponentBuilder/ComponentMap'

import { trackSatuEvent } from '../../../lib/satu-event-tracker'

const Header = () => {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL
  const DropdownMenu = UIComponentMap.DropdownMenu
  const router = useRouter()

  // Helper function to get page name from current route
  const getPageName = () => {
    const path = router.pathname
    if (path === '/tickets') return 'LACAK STATUS TICKET'
    if (path === '/dasbor') return 'DASBOR PENGADUAN PUBLIK'
    return 'HOMEPAGE'
  }

  const handlePusatInformasiClick = (e: React.MouseEvent) => {
    e.preventDefault()

    trackSatuEvent({
      activity_type: 'CLICK_PUSAT_INFORMASI',
      page_name: getPageName(),
      additional_data: [
        {
          key: 'page_location',
          value: 'NAV_HEADER',
        },
      ],
    })

    // Navigate after tracking
    setTimeout(() => {
      window.location.href =
        'https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id'
    }, 100)
  }

  const handleDasborClick = () => {
    trackSatuEvent({
      activity_type: 'CLICK_DASBOR_PENGADUAN',
      page_name: getPageName(),
      additional_data: [
        {
          key: 'page_location',
          value: 'NAV_HEADER',
        },
      ],
    })
  }

  const handleLacakStatusClick = () => {
    trackSatuEvent({
      activity_type: 'CLICK_LACAK_STATUS_TIKET',
      page_name: getPageName(),
      additional_data: [
        {
          key: 'page_location',
          value: 'NAV_HEADER',
        },
      ],
    })
  }

  const handlePusatInformasiMobileClick = (e: React.MouseEvent) => {
    e.preventDefault()

    trackSatuEvent({
      activity_type: 'CLICK_PUSAT_INFORMASI',
      page_name: getPageName(),
      additional_data: [
        {
          key: 'page_location',
          value: 'NAV_HEADER_MOBILE',
        },
      ],
    })

    // Navigate after tracking
    setTimeout(() => {
      window.location.href =
        'https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id'
    }, 100)
  }

  const handleDasborMobileClick = (e: React.MouseEvent) => {
    e.preventDefault()

    trackSatuEvent({
      activity_type: 'CLICK_DASBOR_PENGADUAN',
      page_name: getPageName(),
      additional_data: [
        {
          key: 'page_location',
          value: 'NAV_HEADER_MOBILE',
        },
      ],
    })

    // Navigate after tracking
    setTimeout(() => {
      router.push('/dasbor')
    }, 100)
  }

  const handleLacakStatusMobileClick = (e: React.MouseEvent) => {
    e.preventDefault()

    trackSatuEvent({
      activity_type: 'CLICK_LACAK_STATUS_TIKET',
      page_name: getPageName(),
      additional_data: [
        {
          key: 'page_location',
          value: 'NAV_HEADER_MOBILE',
        },
      ],
    })

    // Navigate after tracking
    setTimeout(() => {
      router.push('/tickets')
    }, 100)
  }

  return (
    <header>
      <div
        className="flex items-center bg-white w-full border-b ult-header-desktop"
        style={{ left: 0, right: 0, top: 0, position: 'fixed', zIndex: 99 }}
      >
        <div
          id="navbarSection"
          className="grid grid-flow-col-dense bg-white w-full hidden md:grid"
          style={{ padding: '1rem 2rem', maxWidth: '1240px', margin: 'auto' }}
        >
          <div
            className="flex flex-row items-center row-span-3"
            style={{ maxWidth: '280px' }}
          >
            <a href={`${baseUrl}`}>
              <Image
                src="/images/logo-kemendikdasmen-ult.png"
                width={180}
                height={60}
                alt="Logo Kemendikdasmen"
              />
            </a>
          </div>
          <div className="flex flex-row items-center w-full row-span-3 justify-between gap-3">
            <a
              href="https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id"
              style={{ textDecoration: 'none' }}
              onClick={handlePusatInformasiClick}
            >
              <p className="text-base text-charcoal">Pusat Informasi</p>
            </a>
            <a href="https://dikdasmen.lapor.go.id/">
              <p className="text-base text-charcoal">SP4N-LAPOR</p>
            </a>
            <Link
              href="/dasbor"
              onClick={handleDasborClick}
              style={{ textDecoration: 'none' }}
            >
              <p className="text-base text-charcoal">Dasbor Pengaduan Publik</p>
            </Link>
            <Link href="/tickets" onClick={handleLacakStatusClick}>
              <span className="text-base text-charcoal">
                Lacak Status Tiket Laporan
              </span>
            </Link>
            <DropdownMenu
              key="ddn-menu-1"
              placement="bottom-end"
              triggerText="Hubungi Kami"
              iconName="arrow_drop_down"
              className="text-base text-charcoal"
              size="sm"
              items={[
                {
                  id: 'desktop-menu-2',
                  text: 'Pusat Panggilan 177',
                  link: 'tel:177',
                  className: 'block px-4 py-2 text-base text-charcoal',
                },
                {
                  id: 'desktop-menu-3',
                  text: 'Layanan Tatap Muka',
                  link: 'https://ult.kemendikdasmen.go.id/site/ult-prosedur-tatap-muka',
                  className: 'block px-4 py-2 text-base text-charcoal',
                },
                {
                  id: 'desktop-menu-4',
                  text: 'Formulir Pengaduan',
                  link: 'https://pengaduan.ult.kemendikdasmen.go.id/hc/en-gb/requests/new',
                  className: 'block px-4 py-2 text-base text-charcoal',
                },
              ]}
            />
          </div>
        </div>
      </div>
      <div
        className="bg-white lg:hidden mobile-header-white"
        style={{ left: 0, right: 0, top: 0, position: 'fixed', zIndex: 99 }}
      >
        <div className="w-full flex flex-row gap-4 justify-between items-center px-6 py-4">
          <a href={`${baseUrl}`}>
            <Image
              src="/images/logo-kemendikdasmen-ult.png"
              width={150}
              height={50}
              alt="Logo Kemendikdasmen"
            />
          </a>
          <DropdownMenu
            key="mobile-ddn-menu-1"
            placement="bottom-end"
            triggerText=""
            iconName="menu"
            iconSize="lg"
            size="sm"
            className="mt-2"
            items={[
              {
                id: 'mobile-menu-1',
                text: 'Pusat Informasi',
                link: 'https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id',
                className: 'text-bold--force',
                onClick: handlePusatInformasiMobileClick,
              },
              {
                id: 'mobile-menu-2',
                text: 'SP4N-LAPOR',
                link: 'https://kemendikdasmen.lapor.go.id/',
                className: 'text-bold--force',
              },
              {
                id: 'mobile-menu-3a',
                text: 'Dasbor Pengaduan Publik',
                link: '/dasbor',
                className: 'text-bold--force',
                onClick: handleDasborMobileClick,
              },
              {
                id: 'mobile-menu-3b',
                text: 'Lacak Status Tiket Laporan',
                link: '/tickets',
                className: 'text-bold--force',
                onClick: handleLacakStatusMobileClick,
              },
              {
                id: 'mobile-menu-4',
                text: 'Hubungi Kami',
                type: 'text',
                className: 'text-bold--force',
              },
              {
                id: 'mobile-menu-6',
                text: 'Pusat Panggilan 177',
                link: 'tel:177',
                className: 'ml-2',
              },
              {
                id: 'mobile-menu-7',
                text: 'Layanan Tatap Muka',
                link: 'https://ult.kemendikdasmen.go.id/site/ult-prosedur-tatap-muka',
                className: 'ml-2',
              },
              {
                id: 'mobile-menu-8',
                text: 'Formulir Pengaduan',
                link: 'https://pengaduan.ult.kemendikdasmen.go.id/hc/en-gb/requests/new',
                className: 'ml-2',
              },
            ]}
          />
        </div>
      </div>
      <div
        className="flex flex-row items-center w-full justify-center ticket-header-blue"
        style={{
          left: 0,
          right: 0,
          top: '92px',
          position: 'fixed',
          zIndex: 22,
        }}
      >
        <div className="bg-lightBlue w-full h-full p-2 pl-[2rem] md:pl-2">
          <p
            id="infoSection"
            className="text-left md:text-center text-sm font-semibold"
            style={{ color: '#103178' }}
          >
            Informasi Jam Layanan ULT Layanan Tatap Muka: 08.00 -15.00 | Layanan
            Contact Center: 08.00-17.00
          </p>
        </div>
      </div>
    </header>
  )
}

export default Header
